

export const initBackgroundSync = async (authenticationStore, itemsStore) => {

};